import jQuery from './plugins/jQuery';
import './plugins/Bootstrap';

import './plugins/Craft.js';
import './components/craft-cookie-consent'
import initMobileNav from './components/MobileNav.js';
import initHeadroom from './components/Headroom.js';
import initFancybox from './components/Fancybox.js';
import initAnchors from './components/AnchorLink.js';
import initSlickCarousel from './components/SlickCarousel.js';
import initCustomForms from './components/CustomForms.js';
import initStickyAnchorPanel from './components/StickyAnchorPanel.js';
import initVideoPlayButton from './components/VideoPlayButton.js';
import initClipboard from './components/Clipboard.js';
import initJsStyles from  './components/JsStyles';

jQuery(function () {
    initMobileNav();
    initHeadroom();
    initFancybox();
    initAnchors();
    initSlickCarousel();
    initCustomForms();
    initStickyAnchorPanel();
    initVideoPlayButton();
    initClipboard();
    initJsStyles();

    window.initFancybox = initFancybox;
});
